<template>
        <div id="invoice-page">
                <!-- SELECCION DE A QUIEN VA DIRIGIDA  -->
                <vx-card>
                        <vs-row
                                class="leading-loose p-base"
                                vs-align="flex-start"
                                vs-justify="center"
                                vs-type="flex"
                                vs-w="12"
                        >
                                <vs-col vs-w="12">
                                        <h2>Informacion General</h2>
                                </vs-col>
                                <div class="mt-4">
                                        <h4 class="mb-8">¿ A quien va dirigida ?</h4>
                                        <vs-col vs-w="6">
                                                <vs-radio v-model="invoiceData.to" vs-value="all">Todos</vs-radio>
                                        </vs-col>
                                        <vs-col vs-w="6">
                                                <vs-radio v-model="invoiceData.to" vs-value="unique">Cliente</vs-radio>
                                        </vs-col>
                                </div>
                                <div v-if="invoiceData.to === 'unique'" class="vx-col w-full">
                                        <vs-select
                                                v-model="invoiceData.customer"
                                                autocomplete
                                                class="w-full select-large mt-8"
                                                no-data="No hay datos por el momento"
                                                placeholder="Selecciona un Cliente"
                                                @change="selectedCustomer(invoiceData.customer)"
                                        >
                                                <vs-select-item
                                                        v-for="(item, index) in customers"
                                                        :key="index"
                                                        :text="
                                                                item.unidad.nombre_bloque +
                                                                        ' ' +
                                                                        item.unidad.nombre_unidad
                                                        "
                                                        :value="item.id"
                                                        class="w-full"
                                                />
                                        </vs-select>
                                </div>
                        </vs-row>
                </vx-card>

                <!-- ALL CUSTOMERs INVOICE -->
                <vx-card v-if="invoiceData.to === 'all'" class="mt-10">
                        <!-- INVOICE METADATA -->
                        <div class="vx-row leading-loose p-base">
                                <div class="vx-col w-full md:w-1/3 mt-base">
                                        <img
                                                :src="
                                                        settings === null
                                                                ? require('@/assets/images/logo/logo.png')
                                                                : settings.logo_path
                                                "
                                                alt="urblock-logo"
                                                height="auto"
                                                width="150px"
                                        />
                                </div>
                                <div class="vx-col w-full md:w-1/3">
                                        <h1>Factura</h1>
                                        <div class="invoice__invoice-detail mt-6">
                                                <h6>FACTURA NO.</h6>
                                                <p class="uppercase">{{ invoiceId(conjuntos[0].nombre) }}</p>

                                                <h6 class="mt-4">FECHA DE FACTURACION</h6>
                                                <p>{{ new Date() | moment }}</p>

                                                <h6 class="mt-4">FECHA DE VENCIMIENTO</h6>

                                                <datetime
                                                        v-model="invoiceData.fechaVencimiento"
                                                        input-class="vs-inputx vs-input--input normal"
                                                        class="mt-4"
                                                        :phrases="phrases"
                                                        value-zone="UTC-5"
                                                        :max-datetime="disabledDates.from"
                                                        :min-datetime="disabledDates.to"
                                                        format="DDDD"
                                                        placeholder="Selecciona una fecha"
                                                ></datetime>
                                        </div>
                                </div>
                                <div class="vx-col w-full md:w-1/3 mt-12">
                                        <h5>Copropiedad {{ conjuntos[0].nombre }}</h5>
                                        <div class="invoice__company-info my-4">
                                                <p class="capitalize">
                                                        {{ conjuntos[0].calle + ' ' + conjuntos[0].numero }}
                                                </p>
                                                <p class="capitalize">
                                                        {{
                                                                conjuntos[0].ciudad +
                                                                        ' ' +
                                                                        conjuntos[0].departamento +
                                                                        ' ' +
                                                                        conjuntos[0].pais
                                                        }}
                                                </p>
                                        </div>
                                        <div class="invoice__company-contact">
                                                <p class="flex items-center">
                                                        <feather-icon
                                                                icon="MailIcon"
                                                                svg-classes="h-4 w-4"
                                                        ></feather-icon>
                                                        <span class="ml-2">{{ conjuntos[0].email }}</span>
                                                </p>
                                                <p class="flex items-center">
                                                        <feather-icon
                                                                icon="PhoneIcon"
                                                                svg-classes="h-4 w-4"
                                                        ></feather-icon>
                                                        <span class="ml-2">{{ conjuntos[0].telefono }}</span>
                                                </p>
                                        </div>
                                </div>
                        </div>

                        <!-- INVOICE CONTENT -->
                        <div class="p-base mt-12">
                                <!-- INVOICE TASKS TABLE -->
                                <vs-table
                                        :data="invoiceData.products"
                                        hover-flat
                                        no-data-text="No hay datos disponibles"
                                >
                                        <!-- HEADER -->
                                        <template slot="thead">
                                                <vs-th>Identificador</vs-th>
                                                <vs-th>Descripcion</vs-th>
                                                <vs-th>Cantidad</vs-th>
                                                <vs-th>Precio Unitario</vs-th>
                                                <vs-th></vs-th>
                                        </template>

                                        <!-- DATA -->
                                        <template slot-scope="{ data }">
                                                <vs-tr v-for="(tr, index) in data" :key="index">
                                                        <vs-td class="w-1/3">
                                                                <vs-input
                                                                        v-model="data[index].identificador"
                                                                        class="w-full"
                                                                />
                                                        </vs-td>
                                                        <vs-td class="w-1/3">
                                                                <vs-input
                                                                        v-model="data[index].description"
                                                                        class="w-full"
                                                                />
                                                        </vs-td>
                                                        <vs-td class="w-1/6">
                                                                <vs-input v-model="data[index].qty" class="w-full" />
                                                        </vs-td>
                                                        <vs-td class="w-1/6">
                                                                <vx-input-group>
                                                                        <template slot="prepend">
                                                                                <div class="prepend-text bg-primary">
                                                                                        <span>$</span>
                                                                                </div>
                                                                        </template>
                                                                        <vs-input v-model="data[index].unityPrice" />

                                                                        <template slot="append">
                                                                                <div class="append-text bg-primary">
                                                                                        <span>COP</span>
                                                                                </div>
                                                                        </template>
                                                                </vx-input-group>
                                                        </vs-td>
                                                        <vs-td class="w-1/6">
                                                                <vs-button
                                                                        color="danger"
                                                                        type="flat"
                                                                        @click="deleteRow(index)"
                                                                        >Eliminar</vs-button
                                                                >
                                                        </vs-td>
                                                </vs-tr>
                                        </template>
                                </vs-table>

                                <vs-button
                                        color="primary"
                                        icon="icon-plus"
                                        icon-before
                                        icon-pack="feather"
                                        type="line"
                                        @click="addRow()"
                                        >Agregar Fila</vs-button
                                >

                                <div class="vx-row leading-loose">
                                        <div class="vx-col w-full md:w-1/2 mt-base text-area">
                                                <vs-textarea
                                                        v-model="invoiceData.observations"
                                                        class="w-full mr-auto mt-4 h-full"
                                                        counter="300"
                                                        height="128px"
                                                        label="Agrega tus observaciones"
                                                        :counter-danger.sync="counterDanger"
                                                />
                                        </div>
                                        <div class="vx-col w-full md:w-1/2 mt-base">
                                                <!-- INVOICE SUMMARY TABLE -->
                                                <vs-table :data="invoiceData" class="w-full ml-auto mt-4" hover-flat>
                                                        <vs-tr>
                                                                <vs-th class="w-1/4">SUBTOTAL</vs-th>
                                                                <vs-td
                                                                        >{{
                                                                                subtotal | numeralFormat('$ 0,0[.]00')
                                                                        }}
                                                                        COP</vs-td
                                                                >
                                                        </vs-tr>
                                                        <vs-tr v-show="!this.invoiceData.noDisscount">
                                                                <vs-th class="w-1/4">
                                                                        DESCTO (
                                                                        <vs-input-number
                                                                                v-model="invoiceData.discountPercentage"
                                                                                min="1"
                                                                                max="100"
                                                                                size="mini"
                                                                        />%)
                                                                </vs-th>
                                                                <vs-td
                                                                        >{{
                                                                                invoiceData.discountedAmount
                                                                                        | numeralFormat('$ 0,0[.]00')
                                                                        }}
                                                                        COP</vs-td
                                                                >
                                                        </vs-tr>
                                                        <vs-tr>
                                                                <th class="w-1/4">TOTAL</th>
                                                                <td>{{ total | numeralFormat('$ 0,0[.]00') }} COP</td>
                                                        </vs-tr>
                                                </vs-table>
                                        </div>
                                </div>
                        </div>

                        <!-- INVOICE FOOTER -->
                        <div class="invoice__footer text-right p-base">
                                <vs-checkbox v-model="invoiceData.noInterest"
                                        >¿Omitir intereses en esta factura?</vs-checkbox
                                >
                                <vs-checkbox v-model="invoiceData.noDisscount"
                                        >¿Omitir descuentos en esta factura?</vs-checkbox
                                >
                                <vs-checkbox v-model="invoiceData.recurrent">¿Hacer factura recurrente?</vs-checkbox>
                                <vs-button color="primary" type="filled" @click="sendInvoice()"
                                        >Guardar y Enviar</vs-button
                                >
                        </div>
                </vx-card>

                <!-- ONE CUSTOMER INVOICE -->
                <vx-card v-if="customer !== null && invoiceData.to === 'unique'" class="mt-10">
                        <!-- INVOICE METADATA -->
                        <div class="vx-row leading-loose p-base">
                                <div class="vx-col w-full md:w-1/4 mt-base">
                                        <img
                                                :src="
                                                        settings === null
                                                                ? require('@/assets/images/logo/logo.png')
                                                                : settings.logo_path
                                                "
                                                alt="urblock-logo"
                                                height="auto"
                                                width="150px"
                                        />
                                </div>
                                <div class="vx-col w-full md:w-1/4">
                                        <h1>Factura</h1>
                                        <div class="invoice__invoice-detail mt-6">
                                                <h6>FACTURA NO.</h6>
                                                <p class="uppercase">{{ invoiceId(conjuntos[0].nombre) }}</p>

                                                <h6 class="mt-4">FECHA DE FACTURACION</h6>
                                                <p>{{ new Date() | moment }}</p>

                                                <h6 class="mt-4">FECHA DE VENCIMIENTO</h6>

                                                <datetime
                                                        v-model="invoiceData.fechaVencimiento"
                                                        input-class="vs-inputx vs-input--input normal"
                                                        :phrases="phrases"
                                                        class="mt-4"
                                                        format="d MMMM yyyy"
                                                        :max-datetime="disabledDates.from"
                                                        :min-datetime="disabledDates.to"
                                                        placeholder="Selecciona una fecha"
                                                ></datetime>
                                        </div>
                                </div>
                                <div class="vx-col w-full md:w-1/4 mt-12">
                                        <h5>Cliente</h5>
                                        <div class="invoice__recipient-info my-4">
                                                <p class="capitalize">
                                                        {{ customer.firstName + ' ' + customer.lastName }}
                                                </p>
                                                <p class="capitalize">
                                                        {{
                                                                customer.unidad.nombre_bloque +
                                                                        ' ' +
                                                                        customer.unidad.nombre_unidad
                                                        }}
                                                </p>
                                                <p class="capitalize">
                                                        {{ conjuntos[0].calle + ' ' + conjuntos[0].numero }}
                                                </p>
                                                <p class="capitalize">
                                                        {{
                                                                conjuntos[0].ciudad +
                                                                        ' ' +
                                                                        conjuntos[0].departamento +
                                                                        ' ' +
                                                                        conjuntos[0].pais
                                                        }}
                                                </p>
                                        </div>
                                        <div class="invoice__recipient-contact">
                                                <p class="flex items-center">
                                                        <feather-icon
                                                                icon="MailIcon"
                                                                svg-classes="h-4 w-4"
                                                        ></feather-icon>
                                                        <span class="ml-2">{{ customer.email }}</span>
                                                </p>
                                                <p class="flex items-center">
                                                        <feather-icon
                                                                icon="PhoneIcon"
                                                                svg-classes="h-4 w-4"
                                                        ></feather-icon>
                                                        <span class="ml-2">{{ customer.phone }}</span>
                                                </p>
                                        </div>
                                </div>
                                <div class="vx-col w-full md:w-1/4 mt-12">
                                        <h5>Copropiedad {{ conjuntos[0].nombre }}</h5>
                                        <div class="invoice__company-info my-4">
                                                <p class="capitalize">
                                                        {{ conjuntos[0].calle + ' ' + conjuntos[0].numero }}
                                                </p>
                                                <p class="capitalize">
                                                        {{
                                                                conjuntos[0].ciudad +
                                                                        ' ' +
                                                                        conjuntos[0].departamento +
                                                                        ' ' +
                                                                        conjuntos[0].pais
                                                        }}
                                                </p>
                                        </div>
                                        <div class="invoice__company-contact">
                                                <p class="flex items-center">
                                                        <feather-icon
                                                                icon="MailIcon"
                                                                svg-classes="h-4 w-4"
                                                        ></feather-icon>
                                                        <span class="ml-2">{{ conjuntos[0].email }}</span>
                                                </p>
                                                <p class="flex items-center">
                                                        <feather-icon
                                                                icon="PhoneIcon"
                                                                svg-classes="h-4 w-4"
                                                        ></feather-icon>
                                                        <span class="ml-2">{{ conjuntos[0].telefono }}</span>
                                                </p>
                                        </div>
                                </div>
                        </div>

                        <!-- INVOICE CONTENT -->
                        <div class="p-base">
                                <!-- INVOICE TASKS TABLE -->
                                <vs-table
                                        :data="invoiceData.products"
                                        hover-flat
                                        no-data-text="No hay datos disponibles"
                                >
                                        <!-- HEADER -->
                                        <template slot="thead">
                                                <vs-th>Identificador</vs-th>
                                                <vs-th>Descripcion</vs-th>
                                                <vs-th>Cantidad</vs-th>
                                                <vs-th>Precio Unitario</vs-th>
                                                <vs-th></vs-th>
                                        </template>

                                        <!-- DATA -->
                                        <template slot-scope="{ data }">
                                                <vs-tr v-for="(tr, index) in data" :key="index">
                                                        <vs-td class="w-1/3">
                                                                <vs-input
                                                                        v-model="data[index].identificador"
                                                                        class="w-full"
                                                                />
                                                        </vs-td>
                                                        <vs-td class="w-1/3">
                                                                <vs-input
                                                                        v-model="data[index].description"
                                                                        class="w-full"
                                                                />
                                                        </vs-td>
                                                        <vs-td class="w-1/6">
                                                                <vs-input v-model="data[index].qty" class="w-full" />
                                                        </vs-td>
                                                        <vs-td class="w-1/6">
                                                                <vx-input-group>
                                                                        <template slot="prepend">
                                                                                <div class="prepend-text bg-primary">
                                                                                        <span>$</span>
                                                                                </div>
                                                                        </template>
                                                                        <vs-input v-model="data[index].unityPrice" />

                                                                        <template slot="append">
                                                                                <div class="append-text bg-primary">
                                                                                        <span>COP</span>
                                                                                </div>
                                                                        </template>
                                                                </vx-input-group>
                                                        </vs-td>
                                                        <vs-td class="w-1/6">
                                                                <vs-button
                                                                        color="danger"
                                                                        type="flat"
                                                                        @click="deleteRow(index)"
                                                                        >Eliminar</vs-button
                                                                >
                                                        </vs-td>
                                                </vs-tr>
                                        </template>
                                </vs-table>

                                <vs-button
                                        color="primary"
                                        icon="icon-plus"
                                        icon-before
                                        icon-pack="feather"
                                        type="line"
                                        @click="addRow()"
                                        >Agregar Fila</vs-button
                                >

                                <div class="vx-row leading-loose">
                                        <div class="vx-col w-full md:w-1/2 mt-base text-area">
                                                <vs-textarea
                                                        v-model="invoiceData.observations"
                                                        class="w-full mr-auto mt-4 h-full"
                                                        counter="300"
                                                        height="128px"
                                                        label="Agrega tus observaciones"
                                                        :counter-danger.sync="counterDanger"
                                                />
                                        </div>
                                        <div class="vx-col w-full md:w-1/2 mt-base">
                                                <!-- INVOICE SUMMARY TABLE -->
                                                <vs-table :data="invoiceData" class="w-full ml-auto mt-4" hover-flat>
                                                        <vs-tr>
                                                                <vs-th class="w-1/4">SUBTOTAL</vs-th>
                                                                <vs-td
                                                                        >{{
                                                                                subtotal | numeralFormat('$ 0,0[.]00')
                                                                        }}
                                                                        COP</vs-td
                                                                >
                                                        </vs-tr>
                                                        <vs-tr v-show="!this.invoiceData.noDisscount">
                                                                <vs-th class="w-1/4">
                                                                        DESCTO (
                                                                        <vs-input-number
                                                                                v-model="invoiceData.discountPercentage"
                                                                                min="1"
                                                                                max="100"
                                                                                size="mini"
                                                                        />%)
                                                                </vs-th>
                                                                <vs-td
                                                                        >{{
                                                                                invoiceData.discountedAmount
                                                                                        | numeralFormat('$ 0,0[.]00')
                                                                        }}
                                                                        COP</vs-td
                                                                >
                                                        </vs-tr>
                                                        <vs-tr>
                                                                <th class="w-1/4">TOTAL</th>
                                                                <td>{{ total | numeralFormat('$ 0,0[.]00') }} COP</td>
                                                        </vs-tr>
                                                </vs-table>
                                        </div>
                                </div>
                        </div>

                        <!-- INVOICE FOOTER -->
                        <div class="invoice__footer text-right p-base">
                                <vs-checkbox v-model="invoiceData.noInterest"
                                        >¿Omitir intereses en esta factura?</vs-checkbox
                                >
                                <vs-checkbox v-model="invoiceData.noDisscount"
                                        >¿Omitir descuentos en esta factura?</vs-checkbox
                                >
                                <vs-checkbox v-model="invoiceData.recurrent">¿Hacer factura recurrente?</vs-checkbox>
                                <vs-button color="primary" type="filled" @click="sendInvoice()"
                                        >Guardar y Enviar</vs-button
                                >
                        </div>
                </vx-card>
        </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { es } from 'vuejs-datepicker/dist/locale';
import { mapState } from 'vuex';
import moment from 'moment';

export default {
        data() {
                return {
                        es: es,
                        phrases: { ok: 'Listo', cancel: 'Cancelar' },
                        counterDanger: false,
                        invoiceData: {
                                noInterest: false,
                                noDisscount: false,
                                recurrent: false,
                                to: '',
                                invoiceNo: '',
                                customer: null,
                                observations: '',
                                conjunto_uuid: null,
                                products: [
                                        {
                                                identificador: '',
                                                description: '',
                                                qty: 1,
                                                unityPrice: 0,
                                        },
                                ],
                                fechaVencimiento: '',
                                subtotal: '',
                                grandTotal: '',
                                discountedAmount: 0,
                                discountPercentage: 0,
                        },
                        disabledDates: {
                                to: new Date(
                                        new Date().getFullYear(),
                                        new Date().getMonth(),
                                        new Date().getDate()
                                ).toISOString(),
                                from: new Date(new Date().getFullYear(), new Date().getMonth() + 5, 29).toISOString(),
                        },
                };
        },
        computed: {
                ...mapState(['customers', 'customer', 'conjuntos', 'settings', 'invoices']),
                subtotal: function() {
                        return this.invoiceData.products.reduce(function(carry, product) {
                                return carry + parseFloat(product.qty) * parseFloat(product.unityPrice);
                        }, 0);
                },

                disscount: function() {
                        if (this.invoiceData.noDisscount) {
                                return '0';
                        } else {
                                return (this.subtotal / 100) * this.invoiceData.discountPercentage;
                        }
                },
                total: function() {
                        if (this.invoiceData.noDisscount) {
                                this.invoiceData.discountedAmount = '0';
                                return this.subtotal;
                        } else {
                                this.invoiceData.discountedAmount = this.disscount;
                                return this.subtotal - parseFloat(this.invoiceData.discountedAmount);
                        }
                },
        },
        created() {
                this.$vs.loading({
                        type: 'corners',
                        background: 'rgba(45, 166, 179, 1)',
                        color: 'rgb(255, 255, 255)',
                });
                this.$store.dispatch('getInvoices').then(() => {
                        if (this.$store.state.settings) {
                                if (Object.keys(this.$store.state.settings).length > 0) {
                                        this.invoiceData.discountPercentage = this.$store.state.settings.global_percent_discount_amount;
                                        this.$vs.loading.close();
                                } else {
                                        this.invoiceData.discountPercentage = 0;
                                        this.$vs.loading.close();
                                }
                        } else {
                                console.log("Can't load data");
                                this.invoiceData.discountPercentage = 0;
                                this.$vs.loading.close();
                        }
                });
        },
        methods: {
                getPadded: function(num) {
                        var str = '' + num;
                        var pad = '000';
                        return pad.substring(0, pad.length - str.length) + str;
                },
                invoiceId(val, val2) {
                        if (this.invoices.length > 0) {
                                var invoiceIncrement = parseInt(this.invoices[0].sufijo) + 1;
                                const invoiceId =
                                        this.$options.filters.acronimoCopropiedad(val) +
                                        '-' +
                                        this.getPadded(invoiceIncrement);
                                this.invoiceData.invoiceNo = invoiceId;
                                return invoiceId;
                        } else {
                                const invoiceId = this.$options.filters.acronimoCopropiedad(val) + '-001';
                                this.invoiceData.invoiceNo = invoiceId;
                                return invoiceId;
                        }
                },
                sendInvoice() {
                        this.invoiceData.subtotal = this.subtotal;
                        this.invoiceData.grandTotal = this.total;
                        this.invoiceData.conjunto_uuid = this.conjuntos[0].id;
                        this.$store
                                .dispatch('createInvoice', this.invoiceData)
                                .then(result => {
                                        this.openAlert('succes', result.message);
                                        this.$router.go('/');
                                })
                                .catch(err => {
                                        this.openAlert('danger', err.message);
                                });
                },
                addRow() {
                        this.invoiceData.products.push({
                                identificador: '',
                                description: '',
                                qty: 1,
                                unityPrice: 0,
                        });
                },
                deleteRow(producto) {
                        this.invoiceData.products.splice(producto, 1);
                },
                selectedCustomer(id) {
                        this.$store.dispatch('getCustomerInfo', id);
                },
                openAlert(color, message) {
                        this.colorAlert = color || this.getColorRandom();
                        this.$vs.dialog({
                                color: this.colorAlert,
                                title: 'Aviso',
                                text: this.colorAlert === 'danger' ? 'Por favor revisa todos los campos' : message,
                                accept: this.acceptAlert,
                        });
                },
                acceptAlert() {
                        this.$vs.notify({
                                color: this.colorAlert,
                                title: 'Aviso',
                                text:
                                        this.colorAlert === 'danger'
                                                ? ' Por favor revisa todos los campos'
                                                : 'Continuemos',
                        });
                },
        },
        components: {
                Datepicker,
        },
        filters: {
                moment: function(date) {
                        return moment(date)
                                .locale('es')
                                .format('LL');
                },
                acronimoCopropiedad(val) {
                        var matches = val.match(/\b(\w)/g);
                        var acronym = matches.join('');
                        return acronym;
                },
        },
};
</script>
